import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function CleanTextAiPrivacyPolicyZhCn() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # 隐私政策

"AI学习助手"（以下简称"本应用"）尊重用户的隐私，并最大限度地注意保护个人信息。本应用不收集用户的个人信息，并采取措施保护用户的数据。本隐私政策（以下简称"本政策"）规定了本应用中信息的处理方式。

## 第1条（个人信息的收集和管理方针）

本应用不收集用户的任何个人信息（如姓名、地址、电话号码、电子邮件地址等）。应用内的所有功能都是在不收集个人信息的前提下设计的。此外，为了保护用户的隐私，我们根据个人信息保护法，不收集或存储任何可以识别个人身份的信息。

## 第2条（作业・考试题目的图像和数据存储）

在本应用中，用户拍摄的作业和考试题目图像、扫描的文档、手写去除处理后的数据均仅存储在用户的设备中，不会存储在应用外部的服务器上。因此，我们无法访问用户拍摄和存储的图像和数据。我们还保证这些图像数据不会提供给第三方，并将安全地存储在用户的设备中。

## 第3条（AI题目解答功能）

本应用提供将用户拍摄的题目图像发送给AI以获取解答的功能。使用此功能时，题目图像会临时发送到外部AI服务，但不包含个人身份识别信息。发送的图像在解答处理后会被删除，不会长期保存。此外，AI服务提供商不会将这些图像用于其他目的。此功能的使用是可选的，用户可以随时停止使用。

## 第4条（相机和照片库访问）

本应用为提供作业和考试题目的拍摄及扫描功能，可能会请求访问用户设备的相机和照片库权限。这些权限仅用于执行应用的基本功能，我们不会在未经许可的情况下访问用户的照片或相机功能。此外，用户可以随时从设备设置中更改或撤销访问权限。

## 第5条（数据加密和安全）

本应用为保护用户数据，对设备内存储的所有数据使用适当的加密技术。此外，为了最大限度地降低应用使用过程中可能出现的安全风险，我们会定期实施安全更新。但是，用户设备本身的安全需要用户自行适当管理。

## 第6条（应用使用情况分析）

本应用为了改善服务，可能会在不能识别个人身份的范围内分析应用的使用情况（功能使用频率、错误发生情况等）。这些分析数据不包含个人信息，仅收集统计信息，并仅用于应用改进和新功能开发。

## 第7条（与第三方服务的集成）

本应用在AI题目解答功能中使用第三方AI服务。这些服务提供商各自拥有独立的隐私政策，用户数据的处理遵循各服务提供商的政策。本应用会最大限度地减少发送给这些第三方服务的数据，并确保不包含个人信息。

## 第8条（用户权利和数据管理）

本应用确保用户可以完全管理自己的数据。用户可以随时删除应用内的数据，除非用户操作，否则本应用不会向外部发送数据（AI题目解答功能除外）。此外，根据使用条款，由于使用本应用时不使用个人信息，因此不适用于信息披露、更正、删除或停止使用的请求。

## 第9条（对法律要求的响应）

由于本应用不收集个人信息，通常情况下无法响应执法机构等的信息披露要求。但是，如果有法律有效的搜查令或法院命令等，我们将根据法律法规适当响应。

## 第10条（隐私政策的变更）

本应用可能会不时审查本政策的内容，并根据法律修订和应用功能的变更来改变本政策，以提高用户隐私保护。当发生变更时，我们将通过在本应用内发布最新的隐私政策来通知用户，并在发布的同时生效。请用户定期查看本政策。

## 第11条（联系方式）

如果您对本政策有任何问题或疑虑，请通过以下地址与我们联系。如有隐私相关的问题或担忧，请随时联系我们。

电子邮件：linappworks@gmail.com

最终更新日期：2025年8月20日
  `;

  return (
    <Container>
      <Content>
        <Title>隐私政策</Title>
        <MarkdownContainer>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
        <p>Contact us: linappworks@gmail.com</p>
      </Footer>
    </Container>
  );
}

export default CleanTextAiPrivacyPolicyZhCn; 
